export function normalizeDateForApi(value: any): string | null {
  if (!value) return null;
  const str = String(value).trim();
  if (!str) return null;

  const slashMatch = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (slashMatch) {
    const [, day, month, year] = slashMatch;
    return `${year}-${month}-${day}`;
  }

  const dashMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dashMatch) {
    return `${dashMatch[1]}-${dashMatch[2]}-${dashMatch[3]}`;
  }

  const parsed = new Date(str);
  if (!isNaN(parsed.getTime())) {
    return parsed.toISOString().split("T")[0];
  }

  return null;
}

export function mapPttDurumToTebligatDurumu(
  pttDurum: string | null | undefined,
  fallback: string = "gonderildi"
): string {
  if (pttDurum === "teslim_edildi") return "teblig_edildi";
  if (pttDurum === "bila") return "bila_oldu";
  return fallback || "gonderildi";
}

export function resolveBilaTarihi(
  mappedDurum: string,
  pttBilaTarihi: string | null,
  gonderimTarihi: string
): string | null {
  if (mappedDurum !== "bila_oldu") return null;
  return pttBilaTarihi || gonderimTarihi;
}
